import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { logo } from '../utils/icons';

const StyledLogo = styled.i`
  width: ${props => props.size};
  display: inline-block;

  .cls-1 {
    fill: #cd1a1c;
  }

  .cls-2 {
    fill: #1d1d1b;
  }
`;

const Logo = ({ size }) => <StyledLogo size={size}>{logo}</StyledLogo>;

Logo.propTypes = {
  size: PropTypes.string.isRequired
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js